import React from 'react';
import { Route, Redirect } from 'react-router-dom';

import SignedLayout from '../pages/Private/_signedLayout';
import AdminLayout from '../pages/Admin/_adminLayout';
import { store } from '../store';

export default function RouteWrapper({
  component: Component,
  isPrivate,
  isAdmin,
  path,
  exact,
  ...rest
}: {
  component: any;
  isPrivate?: boolean;
  isAdmin?: boolean;
  path?: string;
  exact?: boolean;
}) {
  const { signed } = store.getState().auth;
  const { isActive, isAdmin: userIsAdmin, subscription, trial } = store.getState().user.user;

  const isTrialing =
    (trial && trial.active) ||
    (subscription &&
      subscription.status === 'trialing' &&
      subscription.currentPeriodEnd &&
      new Date(subscription.currentPeriodEnd) > new Date());

  const hasAccess =
    isActive ||
    isTrialing ||
    ['active', 'past_due'].includes((subscription && subscription.status) || '');

  if (isAdmin) {
    if (!signed) {
      return <Redirect to="/login" />;
    }
    if (!userIsAdmin) {
      return <Redirect to="/" />;
    }
    return (
      <Route
        {...rest}
        exact={exact}
        path={path}
        render={props => (
          <AdminLayout>
            <Component {...props} />
          </AdminLayout>
        )}
      />
    );
  }

  if (!signed && isPrivate) {
    return <Redirect to="/login" />;
  }

  if (signed && (path === '/login' || path === '/register') && hasAccess) {
    return <Redirect to="/" />;
  }
  if (signed && isPrivate && !hasAccess && path !== '/plans') {
    return <Redirect to="/plans" />;
  }

  if (signed && isPrivate) {
    return (
      <Route
        {...rest}
        exact={exact}
        path={path}
        render={props => (
          <SignedLayout>
            <Component {...props} />
          </SignedLayout>
        )}
      />
    );
  }

  return <Route {...rest} exact={exact} path={path} component={Component} />; // eslint-disable-line
}

RouteWrapper.defaultProps = {
  isPrivate: false,
  isAdmin: false,
  exact: false,
  path: '',
};
